<p-toast></p-toast>
<div class="ui-g">
    <div class="ui-g-12">
        <div class="card card-w-title">
            <div class="ui-g form-group">
                <div class="ui-g-12" style="text-align-last: right;">
                    <p-progressSpinner *ngIf="this.create_api_result.Posting || this.block_api_result.Posting"
                        [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}" strokeWidth="6">
                    </p-progressSpinner>
                    <button pButton type="button" style="margin-bottom:10px;margin-right:5px;"
                        [disabled]="this.create_api_result.Posting || this.block_api_result.Posting || this.table_api_result.Posting || CreateScheduleDialog"
                        (click)="showDialogToAdd()" label="Add Schedule"></button>
                    <button pButton type="button" style="margin-bottom:10px;margin-right:5px;"
                        [disabled]="this.create_api_result.Posting || this.block_api_result.Posting || this.table_api_result.Posting || CreateScheduleDialog"
                        (click)="confirmSchedulesBlock($event)" label="Delete"></button>
                </div>
                <p-fieldset *ngIf="this.showListForRoles()" [style]="{'width':'87%','border':'1px solid black'}">
                    <p-header><b>View/Edit</b></p-header>
                    <div class="ui-g-12">
                        <!-- <div class="card card-w-title"> -->
                        <div class="p-field p-grid">
                            <div class="p-col">
                                <p-dropdown class="notranslate" [(ngModel)]="current_user_guid" [options]="doctor_list" name="doctors"
                                    [filter]="true" #doctors="ngModel" required placeholder="Select a Doctor"
                                    [disabled]="this.list_api_result.Posting || this.create_api_result.Posting || this.block_api_result.Posting || this.table_api_result.Posting || CreateScheduleDialog">
                                </p-dropdown>

                                <div *ngIf="doctors.invalid && (doctors.dirty || doctors.touched)"
                                    class="alert alert-danger">
                                    <div *ngIf="doctors.errors.required">
                                        Choose a doctor.
                                    </div>

                                </div>
                                <div class="ui-g-12" style="float: right;">

                                    <div class="ui-g-12">
                                        <div class="p-field-checkbox">
                                            <p-checkbox [(ngModel)]="is_filter" [binary]="true" inputId="binary"
                                                (ngModelChange)="CallCountryAndSpecialtyFn()" name="filter"
                                                [disabled]="this.list_api_result.Posting || this.create_api_result.Posting || this.block_api_result.Posting || this.table_api_result.Posting || CreateScheduleDialog">
                                            </p-checkbox>
                                            <label for="binary" style="margin-left: 2%;">Filter by Country or
                                                Specialty?</label>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="this.is_filter">
                                    <div class="ui-g-12" style="float: right;">
                                        <div class="ui-g-12">Country : </div>
                                        <div class="ui-g-12">
                                            <p-dropdown [(ngModel)]="param.country_id" [options]="countries"
                                                [filter]="true" name="countriesModel" (ngModelChange)="GetDoctors()"
                                                #countriesModel="ngModel" placeholder="Select a Country"
                                                [disabled]="this.list_api_result.Posting || this.create_api_result.Posting || this.block_api_result.Posting || this.table_api_result.Posting || !this.is_filter || CreateScheduleDialog">
                                            </p-dropdown>
                                        </div>
                                    </div>
                                    <div class="ui-g-12" style="float: right;">
                                        <div class="ui-g-12">Specialty : </div>
                                        <div class="ui-g-12">
                                            <p-dropdown [(ngModel)]="param.specialty_id" [options]="specialties"
                                                [filter]="true" name="specialtiesModel" #specialtiesModel="ngModel"
                                                placeholder="Select a Specialty" (ngModelChange)="GetDoctors()"
                                                [disabled]="this.list_api_result.Posting || this.create_api_result.Posting || this.block_api_result.Posting || this.table_api_result.Posting|| !this.is_filter || CreateScheduleDialog">
                                            </p-dropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button pButton type="button" style="margin-bottom:10px;margin-right:5px;"
                            [disabled]="this.create_api_result.Posting || this.block_api_result.Posting || this.table_api_result.Posting || current_user_guid==null || CreateScheduleDialog"
                            (click)="getSchedules()" label="Get Schedules"></button>
                        <button pButton type="button" style="margin-bottom:10px;margin-right:5px;"
                            [disabled]="this.create_api_result.Posting || this.block_api_result.Posting || this.table_api_result.Posting || doctor_user_id==current_user_guid || CreateScheduleDialog"
                            (click)="CancelSchedulesQuery()" label="Cancel"></button>
                        <!-- </div> -->
                    </div>
                </p-fieldset>
            </div>
        </div>
    </div>
</div>
<br><br>

<div class="mat-elevation-z8">

    <div class="table-responsive text-center justify-content-center" style="
            font-size: 14px;
            margin-bottom: 20px;
            text-align: center;
            vertical-align: center;
        ">
        <p-table [value]="schedules" #dt1 dataKey="date" [loading]="this.table_api_result.Posting" [scrollable]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resizableColumns]="true"
            [autoLayout]="true" [style]="{'width':'100%'}">
            <ng-template pTemplate="caption">
            </ng-template>


            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 25%;" pSortableColumn="sr_no">
                        <b>Sr No</b>
                        <p-sortIcon field="sr_no"></p-sortIcon>
                    </th>
                    <th style="width: 25%;" pSortableColumn="fromtime">
                        <b>Slot Time</b>
                        <p-sortIcon field="fromtime"></p-sortIcon>
                    </th>
                    <th style="width: 25%;" pSortableColumn="status">
                        <b>Status</b>
                        <p-sortIcon field="status"></p-sortIcon>
                    </th>
                    <th style="width: 25%;">
                        <b>Delete</b>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customer let-rowIndex="rowIndex" let-expanded="expanded">
                <tr *ngIf="rowGroupMetadata[getDateResettingTime(customer.slot_time)].index === rowIndex">
                    <td colspan="4" style="vertical-align: inherit;">
                        <button style="float: left;background-color: transparent;color:black;border:0px" type="button"
                            pButton pRipple [pRowToggler]="customer"
                            class="p-button-text p-button-rounded p-button-plain p-mr-2"
                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                        <span style="font-weight: bold;float:left" class="p-text-bold p-ml-2">{{customer.date}}</span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-schedule>
                <tr [pSelectableRow]="schedule">
                    <td style="width: 25%;">{{ schedule.sr_no+1 }}</td>
                    <td style="width: 25%;">{{ (schedule.slot_time | date:'medium')}}</td>
                    <td style="width: 25%;">{{ schedule.status?'Unavailable':'Available' }}</td>
                    <td style="width: 25%;">
                        <p-checkbox *ngIf="schedule.status==false" [(ngModel)]="schedule.block" [binary]="true">
                        </p-checkbox>
                        <div *ngIf="schedule.status==true">
                            Appointment Scheduled
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="4">No Data Found.</td>
                </tr>
            </ng-template>
        </p-table>

        <div class="ui-g-12">
            <app-error-messages [api_result]="this.table_api_result">
            </app-error-messages>
        </div>

    </div>
</div>


<p-confirmDialog [style]='{"width":"60vw"}' key="confirm-block-schedule" header="Block Schedule" acceptLabel="Yes"
    rejectLabel="No" [(visible)]="confirmScheduleBlock"></p-confirmDialog>

<p-dialog *ngIf="CreateScheduleDialog" header="Create Schedule" [resizable]="true" [contentStyle]='{"height":"700px"}'
    [responsive]="true" [(visible)]="CreateScheduleDialog" (onHide)="Cancel()">
    <div class="ui-g">
        <div style="margin-bottom: 2px; width: 600px;">
            <form accept-charset="UTF-8" #Createform="ngForm" (submit)="SubmitCreateScheduleData()">
                <div>
                    <div class="card no-margin">
                        <div>
                            <div class="ui-g form-group">
                                <div class="ui-g-12 ui-md-4">
                                    <label for="datee">From Date<span class="req">*</span></label>
                                </div>
                                <div class="ui-g-12 ui-md-8">
                                    <p-calendar id="datee" class="notranslate" [minDate]="date" hourFormat="24" [(ngModel)]="selectedDate"
                                        name="datee" #datee="ngModel" required [showIcon]="true" inputId="time">
                                    </p-calendar>

                                    <div *ngIf="datee.invalid && (datee.dirty || datee.touched)"
                                        class="alert alert-danger">
                                        <div *ngIf="datee.errors.required" class="invalid">
                                            Date is required.
                                        </div>

                                    </div>
                                </div>

                                <div class="ui-g-12 ui-md-4">
                                    <label for="from_m">From Time<span class="req">*</span></label>
                                </div>
                                <div class="ui-g-12 ui-md-8">
                                    <p-calendar id="from_m" class="notranslate" [timeOnly]="true" hourFormat="12" [stepMinute]="30"
                                        [readonlyInput]="true" [(ngModel)]="fromTime" name="fromtime"
                                        #fromtime="ngModel" required [defaultDate]="this.defaultDate" [showIcon]="true"
                                        inputId="time">
                                    </p-calendar>

                                    <div *ngIf="fromtime.invalid && (fromtime.dirty || fromtime.touched)"
                                        class="alert alert-danger">
                                        <div *ngIf="fromtime.errors.required" class="invalid">
                                            From Time is required.
                                        </div>

                                    </div>
                                </div>
                                <div class="ui-g-12 ui-md-4">
                                    <label for="to_m">To Time<span class="req">*</span></label>
                                </div>
                                <div class="ui-g-12 ui-md-8">
                                    <p-calendar id="to_m" class="notranslate" [timeOnly]="true" hourFormat="12" [stepMinute]="30"
                                        [readonlyInput]="true" [(ngModel)]="toTime" name="totime" #totime="ngModel"
                                        [defaultDate]="this.defaultDate" [disabled]="fromTime==null" required
                                        [showIcon]="true" inputId="time">
                                    </p-calendar>
                                    <!-- [minDate]="schedule.fromtime" -->
                                    <div *ngIf="totime.invalid && (totime.dirty || totime.touched)"
                                        class="alert alert-danger">
                                        <div *ngIf="totime.errors.required" class="invalid">
                                            To Time is required.
                                        </div>

                                    </div>
                                </div>
                                <div class="ui-g-12 ui-md-8" *ngIf="fromTime!=null && toTime!=null && fromTime>=toTime"
                                    class="alert alert-danger">
                                    <span>
                                        Invalid Time Slots Selected
                                    </span>
                                </div>

                                <div class="ui-g-12">

                                    <p-checkbox [(ngModel)]="is_end_date" binary="true" name="is_end_date_binary"
                                        #is_end_date_binary="ngModel" inputId="binary" (click)="selected_end_date=null"
                                        required></p-checkbox>
                                    <label for="binary" style="margin-left: 2%;">Do you want to have the same schedule
                                        for more than one
                                        day?</label>

                                </div>
                                <div class="ui-g-12 ui-md-4" *ngIf="is_end_date">
                                    <label for="end_date_model">To Date<span class="req">*</span></label>
                                </div>
                                <div class="ui-g-12 ui-md-8" *ngIf="is_end_date">
                                    <p-calendar id="end_date_model" class="notranslate" [minDate]="selectedDate" hourFormat="24"
                                        [(ngModel)]="selected_end_date" name="end_date_model" #end_date_model="ngModel"
                                        [showIcon]="true" inputId="time" [required]="is_end_date">
                                    </p-calendar>

                                    <div *ngIf="end_date_model.invalid && (end_date_model.dirty || end_date_model.touched)"
                                        class="alert alert-danger">
                                        <div *ngIf="end_date_model.errors.required" class="invalid">
                                            End date is required.
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="ui-g-12">
                    <app-error-messages [api_result]="this.create_api_result">
                    </app-error-messages>
                </div>

                <p-progressSpinner *ngIf="this.create_api_result.Posting || this.block_api_result.Posting"
                    [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}" strokeWidth="6">
                </p-progressSpinner>
                <p-footer>
                    <button pButton type="button" label="Cancel" style="margin-bottom:10px;margin-right:5px;"
                        [disabled]="this.create_api_result.Posting || this.block_api_result.Posting" (click)="Cancel()"
                        class="ui-button-danger ui-button-rounded"></button>
                    <button pButton type="submit" label="Submit" style="margin-bottom:10px;margin-right:5px;"
                        class="ui-button-info ui-button-rounded"
                        [disabled]="this.create_api_result.Posting || this.block_api_result.Posting ||!Createform.valid || fromTime!=null && toTime!=null && fromTime>=toTime"></button>
                </p-footer>
            </form>
        </div>
    </div>
</p-dialog>